// extracted by mini-css-extract-plugin
module.exports = {"spacer":"StatefulContainer_spacer__2Yos1","img":"StatefulContainer_img__2VjDp"};